export default __webpack_public_path__ + "static/media/reassign-big.ba50ad3c.svg";